import { createSelector } from 'reselect';
import { RootState } from 'typesafe-actions';
import { PlanDetailsState } from './reducer';

export const getErrors = (state: RootState) => state.planDetails.errors;

export const getPlanDetails = (state: RootState) => state.planDetails;

export const getPlanDetailsData = createSelector(
  getPlanDetails,
  (state: PlanDetailsState) => state.planDetails,
);

export const getIsFetching = createSelector(
  getPlanDetails,
  (state: PlanDetailsState) => state.isFetching,
);

export const getPrefetchedFilters = createSelector(getPlanDetails, (state: PlanDetailsState) => ({
  filters: state.prefetchedPlanDetails.filters,
  total: state.prefetchedPlanDetails.total,
}));

export const getIsFetchingFilters = createSelector(
  getPlanDetails,
  (state: PlanDetailsState) => state.isFetchingFilters,
);

export const getIsFetchingMoreItems = createSelector(
  getPlanDetails,
  (state: PlanDetailsState) => state.isFetchingMoreItems,
);

export const hasMorePlanItems = createSelector(getPlanDetails, (state: PlanDetailsState) => {
  const { offset, total, limit } = state.planDetails;
  return total > offset + limit;
});
